import * as React from "react";
import { query } from "./graph";
import { useQuery } from "@apollo/client";
import CircularProgress from "@mui/material/CircularProgress";
import QaDashboardOrderDetailsCard from "../QaDashboardOrderDetailsCard";
import Ticker from "react-ticker";

const ORDERS_PER_PAGE = 1000;

const QaDashboardOrderDetail = ({ productionStationId }) => {
  const { data, loading, error } = useQuery(query, {
    variables: {
      first: ORDERS_PER_PAGE,
      filters: {
        productionStationId: productionStationId
      },
      fetchPolicy: "network-only",
      pollInterval: 10000
    }
  });

  if (error) return <h1>Something went wrong</h1>;

  return loading ? (
    <CircularProgress />
  ) : (
    <React.Fragment>
      {data.ordersConnection && (
        <Ticker speed={2}>
          {({ index }) => (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {data.ordersConnection.edges
                .filter(
                  ({ node }) => node.screenPrintingStatus === "IN_PROGRESS"
                )
                .slice(
                  index * 4 >=
                    data.ordersConnection.edges.filter(
                      ({ node }) => node.screenPrintingStatus === "IN_PROGRESS"
                    ).length
                    ? 0
                    : index * 4,
                  index * 4 + 4 >
                    data.ordersConnection.edges.filter(
                      ({ node }) => node.screenPrintingStatus === "IN_PROGRESS"
                    ).length
                    ? data.ordersConnection.edges.filter(
                        ({ node }) =>
                          node.screenPrintingStatus === "IN_PROGRESS"
                      ).length
                    : index * 4 + 4
                )
                .map(edge => (
                  <QaDashboardOrderDetailsCard order={edge.node} />
                ))}
            </div>
          )}
        </Ticker>
      )}
    </React.Fragment>
  );
};

export default QaDashboardOrderDetail;
